import api from '@/api/shelter'

export default {
  state: {
    shelters: [],
    shelter: {}
  },
  mutations: {
    setShelters (state, value) {
      state.shelters = value
    },
    setShelter (state, value) {
      state.shelter = value
    }
  },
  actions: {
    create (store, params) {
      return api.create(params)
    },
    fetch ({commit}) {
      return api.get()
        .then((res) => {
          commit('setShelters', res.data.data)
        })
    },
    fetchOne ({commit}, params) {
      return api.get(params)
        .then((res) => {
          const data = res.data.data[0] || {}
          commit('setShelter', data)
        })
    }
  },
  getters: {
    shelters: (state) => state.shelters,
    shelter: (state) => state.shelter
  },
  namespaced: true
}
